import React from "react";
import useCurrency from "../../hooks/useCurrency";

import {
    Card,
    Tag,
    Button,
    Space,
    Typography,
    Divider
} from "antd";

import {
    EnvironmentOutlined,
    EyeOutlined,
    ShoppingOutlined
} from "@ant-design/icons";

import ProducerBadge
    from "./ProducerBadge";

import {
    useNavigate
} from "react-router-dom";

import getProductImage, { fallbackToDefaultImage }
    from "../../utils/getProductImage";

const ProductDiscoveryCard = ({
                                  product
                              }) => {

    const navigate =
        useNavigate();

    const { currency } =
        useCurrency();

    const imageSource =
        getProductImage(product.productName, product.subCategoryName, product.categoryName);

    // Les lots de l'API marketplace (/sub-category, /search) nomment ces champs
    // sellerCity, sellerCountry, sellerCompanyName, availableStock et publicationStatus.
    const city = product.city || product.sellerCity;
    const country = product.country || product.sellerCountry;
    const companyName = product.companyName || product.sellerCompanyName;
    const stock = product.sellingStock ?? product.availableStock;
    const status = product.status || product.publicationStatus;

    return (

        <Card
            hoverable

            style={{
                borderRadius: 20,
                overflow: "hidden",
                height: "100%",
                border: "1px solid #f0f0f0",
                boxShadow:
                    "0 4px 14px rgba(0,0,0,0.06)"
            }}

            bodyStyle={{
                padding: 18
            }}

            cover={

                <div
                    style={{
                        position: "relative"
                    }}
                >

                    <img
                        alt={product.productName}

                        src={imageSource}

                        onError={fallbackToDefaultImage}

                        style={{
                            height: 240,
                            width: "100%",
                            objectFit: "cover"
                        }}
                    />

                    {/* STATUS */}

                    <Tag
                        color={
                            status === "ACTIVE" || status === "PUBLISHED"
                                ? "green"
                                : "orange"
                        }

                        style={{
                            position: "absolute",
                            top: 12,
                            right: 12,
                            borderRadius: 12,
                            padding: "4px 10px",
                            fontWeight: 600
                        }}
                    >
                        {status}
                    </Tag>

                </div>
            }
        >

            {/* PRODUCT HEADER */}

            <Space
                direction="vertical"
                size={2}
                style={{
                    width: "100%"
                }}
            >

                <Typography.Title
                    level={4}
                    style={{
                        margin: 0
                    }}
                >
                    🌾 {product.productName}
                </Typography.Title>

                <Space wrap>

                    <Tag color="green">
                        {product.varietyName}
                    </Tag>

                    <Tag color="gold">
                        {product.quality}
                    </Tag>

                    {
                        product.norms && (
                            <Tag color="lime">
                                {product.norms}
                            </Tag>
                        )
                    }

                </Space>

            </Space>

            <Divider
                style={{
                    margin: "14px 0"
                }}
            />

            {/* PRODUCER */}

            <ProducerBadge

                producer={
                    companyName ||
                    "Producteur certifié"
                }

                region={
                    city ||
                    "Unknown region"
                }
            />

            {/* LOCATION */}

            <div
                style={{
                    marginTop: 14,
                    color: "#666"
                }}
            >

                <EnvironmentOutlined />

                {" "}

                {city || "Unknown city"}

                {" - "}

                {country || "Unknown country"}

            </div>

            {/* ORIGIN */}

            {
                product.origin && (

                    <div
                        style={{
                            marginTop: 8,
                            fontSize: 13,
                            color: "#888"
                        }}
                    >
                        🌍 Origine :
                        {" "}
                        {product.origin}
                    </div>
                )
            }

            {/* QUANTITY */}

            <div
                style={{
                    marginTop: 18,
                    fontSize: 15
                }}
            >
                📦
                {" "}

                <strong>
                    {product.sellingQuantity}
                </strong>

                {" "}

                {product.measurementUnit}
            </div>

            {/* PRICE */}

            <div
                style={{
                    marginTop: 10,
                    fontSize: 20,
                    fontWeight: 700,
                    color: "#1d7a38"
                }}
            >
                💰
                {" "}

                {product.sellingPrice}

                {" "}

                {product.currency || currency}
            </div>

            {/* STOCK */}

            <div
                style={{
                    marginTop: 8,
                    color:
                        stock > 0
                            ? "#389e0d"
                            : "#cf1322",
                    fontWeight: 500
                }}
            >

                <ShoppingOutlined />

                {" "}

                {
                    stock > 0
                        ? `${stock} en stock`
                        : "Rupture de stock"
                }

            </div>

            {/* ACTION */}

            <Button
                type="primary"

                block

                size="large"

                icon={<EyeOutlined />}

                style={{
                    marginTop: 22,
                    height: 46,
                    borderRadius: 12,
                    fontWeight: 600
                }}

                onClick={() =>
                    navigate(
                        `/products/${
                            product.subCategoryName
                        }/${
                            product.id
                        }`
                    )
                }
            >
                Voir détails
            </Button>

        </Card>
    );
};

export default ProductDiscoveryCard;